export default "__VITE_ASSET__udUIzA$s__"